import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AreasPage } from './areas';

@NgModule({
  declarations: [
    AreasPage,
  ],
  imports: [
    IonicPageModule.forChild(AreasPage),
  ],
})
export class AreasPageModule {}



// WEBPACK FOOTER //
// ./src/pages/areas/areas.module.ts